import { takeEvery } from 'redux-saga/effects'

const takes = ({ types, sagas }) => ([
    takeEvery(types.ADD_PAYMENT_METHOD, sagas.addPaymentMethod),
    takeEvery(types.DELETE_PAYMENT_METHOD, sagas.deletePaymentMethod),
    takeEvery(types.SET_DEFAULT_PAYMENT_METHOD, sagas.setDefaultPaymentMethod),
])

export default takes
